import * as React from 'react'
import { useEffect, useState } from 'react'
import { getManufacturerName, getManufacturerIconPath } from './ManufacturerIconUtil'

interface Props {
    size: number
    path: string
    style: React.CSSProperties
    onIconStatus?: (available: boolean) => void
}

export const ManufacturerIcon: React.FunctionComponent<Props> = ({ size, path, style, onIconStatus }) => {
    const [errored, setErrored] = useState(false)
    const [loaded, setLoaded] = useState(false)

    const manu = getManufacturerName(path)
    const imagePath = getManufacturerIconPath(manu, size)

    useEffect(() => {
        setErrored(false)
        setLoaded(false)
        const img = new Image()
        img.src = imagePath
        img.onload = () => {
            setLoaded(true)
            if (onIconStatus) onIconStatus(true)
        }
        img.onerror = () => {
            setErrored(true)
            if (onIconStatus) onIconStatus(false)
        }
    }, [imagePath, onIconStatus])

    // Don’t render anything until we know it loaded
    if (errored || !loaded) return null

    return <img
        style={{ ...style, height: size, width: 'auto' }}
        src={imagePath}
        height={size}
        width={size}
    />
}
